import { Container, Graphics, Text } from '@pixi/react'
import { useMemo } from 'react'
import { SymbolOdds, SymbolOddsTitle } from './SymbolOdds'
import { ParagraphProps } from './Paragraph2'
import { paragraphStyle } from './textStyle'
import { t } from '@slot-nx/core'

export const Paragraph1 = (props: ParagraphProps) => {
  const width = props.width
  const backgroundIndentSize = 120
  const backgroundIndentOffset = backgroundIndentSize / 2
  const contentIndentSize = 100
  const symbolSpacing = (width - backgroundIndentSize - contentIndentSize) / 4
  const drawBackground = (graphics: any) => {
    graphics.clear()
    graphics.lineStyle(2, '#717171', 1)
    graphics.beginFill(0x222222, 0.8)
    graphics.drawRoundedRect(backgroundIndentOffset, 0, width - backgroundIndentSize, 2050, 20)
    graphics.endFill()
  }

  const content = useMemo(() => {
    return (
      <Container y={props.y}>
        <Graphics draw={drawBackground} />
        <Container name="paragraph symbol">
          <Container x={symbolSpacing} y={contentIndentSize} name="center symbol">
            {SymbolOddsTitle()}
          </Container>
          <Container x={symbolSpacing * 2} y={contentIndentSize}name="left symbol">
            {SymbolOdds('left', props.stake!)}
          </Container>
          <Container x={symbolSpacing * 3} y={contentIndentSize}name="right symbol">
            {SymbolOdds('right', props.stake!)}
          </Container>
          <Container x={symbolSpacing * 4} y={contentIndentSize}name="center symbol">
            {SymbolOdds('center', props.stake!)}
          </Container>

          <Text
            x={60}
            y={2100}
            text={(t('gameRules_title1_content_5'))}
            style={paragraphStyle}
          />
        </Container>

      </Container>
    )
  }, [])

  return content
}
